import React, {FC} from 'react';
import trakLowerLogo from '../../assets/trak-bg-lower.png';

export const TrakLowerBackground: FC = () => (
  <img src={trakLowerLogo} style={{maxWidth: '100%', height: 'auto', position: 'absolute', bottom: 0, left: 0, zIndex: 0, width: '100%'}} />
);
